<template>
  <div class="comp-progress-circle" :class="{ complete }" tabindex="-1">
    <svg viewBox="12 12 24 24" style="transform: rotate(-90deg);">
      <circle
        cx="24" cy="24" r="10"
        stroke-width="2.35"
        stroke-dasharray="64"
        stroke-dashoffset="0"
      />
      <circle
        cx="24" cy="24" r="10"
        stroke-width="2.35"
        stroke-dasharray="64"
        :stroke-dashoffset="percentage"
        stroke-linecap="round"
      />
    </svg>
    <svg viewBox="0 0 14 14" fill="none">
      <path d="M11.6651 2.89986L11.6651 2.89987L4.84891 9.39703L2.33507 7.00088C2.33507 7.00087 2.33506 7.00087 2.33506 7.00087C2.01067 6.69164 1.48953 6.69171 1.16514 7.00085L1.16513 7.00086C0.833949 7.31651 0.833962 7.83345 1.16512 8.14911L1.16512 8.14911L4.26391 11.1028C4.58828 11.4121 5.10973 11.4118 5.43388 11.1028L12.835 4.04814C12.835 4.04814 12.835 4.04814 12.835 4.04813C13.1662 3.73247 13.1662 3.21552 12.8351 2.89988C12.5107 2.59066 11.9895 2.59068 11.6651 2.89986Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
    </svg>

  </div>
</template>

<script>
  export default {
    name: 'ProgressCircle',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      progress: {
        type: Number,
        default: 0,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      percentage() {
        return 64 - (64 * this.progress);
      },
      complete() {
        return this.progress >= 1;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-progress-circle {
  position: relative;
  width: 24px;
  height: 24px;

  & > svg:first-of-type {
    position: absolute;
    left: calc(50% - 12px);
    top: calc(50% - 12px);
    width: 24px;
    height: 24px;

    circle {
      fill: transparent;
      &:first-of-type {
        stroke: $color-black-alpha-10;
        z-index: 1;
      }
      &:last-of-type {
        stroke: $color-signal-orange;
        transition: stroke-dashoffset 0.6s ease-in-out, stroke 0.6s ease-in-out;
        z-index: 1;
      }
    }
  }
  & svg:last-of-type {
    position: absolute;
    top: calc(50% - 7px);
    left: calc(50% - 7px);
    width: 14px;
    height: 14px;
    color: $color-signal-green;
    transform: scale(0, 0);
    opacity: 0;
    transition: opacity 0.6s ease-in-out, transform 0.6s ease-in-out;
  }

  &.complete {
    & > svg:first-of-type > circle:last-of-type {
      stroke: $color-signal-green;
    }
    & > svg:last-of-type {
      opacity: 1;
      transform: scale(1, 1);
    }
  }
}
</style>
